import { Icon } from "@iconify/react";
import "./css/complete.css";
import { Link, useNavigate } from "react-router-dom";
import secureLocalStorage from "react-secure-storage";

function Failed() {
  const cc=secureLocalStorage.getItem('cc')
    secureLocalStorage.clear()
  const Navigate = useNavigate();

  window.onpopstate = (e) =>{
    secureLocalStorage.clear();
    Navigate('/')
  }

  function backtohome() {
    Navigate("/");
  }
  return (
    <>
      <div className="container">
      <button className="link-text absolute flex items-center text-sm bottom-4 left-2 md:left-10">
        <Icon icon="mdi:arrow-left" color="gray" />
        <Link to="https://almondztrade.com/" onClick={()=>secureLocalStorage.clear()}>Back to home</Link>
      </button>
        <div className="complete-container">
          <div className="upper-column">
            <div className="w-fit m-auto border p-4 rounded-full bg-red-300">
              <Icon icon="oi:x" color="red" width="40" height="40" />
            </div>
            <p className="text-[16px] text-center font-semibold mt-5 mb-5">
              Esign Failed !
            </p>
            <p className="para text-center leading-[20px]">
              We noticed that the e-sign request has been cancelled. You cannot
              enable DDPI for your account without e-signing the application.
            </p>
          </div>
          <div className="absolute w-full bottom-[8vh]">
            <p className="text-[10px] text-center leading-[20px] w-3/4 m-auto mb-2 font-semibold">
              To activate DDPI, click "Login" & e-sign your
              application.
            </p>
            <button className="active-btn" onClick={() => backtohome()}>
              Login
            </button>
          </div>
        </div>
      </div>
    </>
  );
}
export default Failed;
